import { CookieSettings } from "../types/cookie";

export const updateGtagConsent = (settings: CookieSettings) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("consent", "update", {
      analytics_storage: settings.analytics ? "granted" : "denied",
      ad_storage: settings.marketing ? "granted" : "denied",
      functionality_storage: settings.preferences ? "granted" : "denied",
      personalization_storage: settings.preferences ? "granted" : "denied",
      security_storage: settings.necessary ? "granted" : "denied",
    });
  }
};
